import { HttpClient, HttpContext, HttpHeaders, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { each, has, isArray, isNil } from 'lodash-es';

import { CoreConfig } from '../../core.module';
import { ShouldIgnoreLoader, ShouldUseErrorMessageFromDescription } from '../../typings/property-force-api';

@Injectable({
  providedIn: 'root'
})
export class AdminPortalApiService {
  private coreConfig = inject<CoreConfig>(CoreConfig);
  private httpClient = inject(HttpClient);

  sendRequest(
    method: string,
    url: string,
    options?: {
      body?: unknown;
      context?: HttpContext;
      headers?:
        | HttpHeaders
        | {
            [header: string]: string | string[];
          };
      observe?: 'body' | 'events' | 'response';
      params?:
        | HttpParams
        | {
            [param: string]: string | number | boolean | ReadonlyArray<string | number | boolean>;
          };
      reportProgress?: boolean;
      responseType?: 'arraybuffer' | 'blob' | 'text' | 'json';
      transferCache?:
        | {
            includeHeaders?: string[];
          }
        | boolean;
      withCredentials?: boolean;
    },
    contextOptions?: {
      ignoreLoader?: boolean;
      shouldUseErrorMessageFromDescription?: boolean;
    }
  ) {
    const headers = new HttpHeaders()
      .set('x-app-id', this.coreConfig.adminPortal.appId)
      .set('x-app-secret', this.coreConfig.adminPortal.appSecret);
    const context = new HttpContext();

    if (has(contextOptions, 'ignoreLoader')) {
      context.set(ShouldIgnoreLoader, !!contextOptions.ignoreLoader);
    } else {
      context.set(ShouldIgnoreLoader, false);
    }

    if (has(contextOptions, 'shouldUseErrorMessageFromDescription')) {
      context.set(ShouldUseErrorMessageFromDescription, true);
    } else {
      context.set(ShouldUseErrorMessageFromDescription, false);
    }

    return this.httpClient.request(method, `${this.coreConfig.adminPortal.baseUrl}${url}`, {
      ...(options || {}),
      context,
      headers
    });
  }

  getQueryParams(parameters?: { [key: string]: string | number | boolean | null | Array<string> }) {
    let params = new HttpParams();
    for (const key in parameters) {
      if (has(parameters, key) && !isNil(parameters[key])) {
        if (isArray(parameters[key])) {
          each(parameters[key], (value) => {
            params = params.append(key, value);
          });
        } else {
          params = params.append(key, parameters[key]);
        }
      }
    }
    return params;
  }
}
